<greco-simple-dialog [data]="dialogData">
  <greco-select-community-agreement
    [community]="data.community"
    [linkedIds]="data.linkedIds"
    [usages]="data.usages"
    [eventId]="data.eventId"
    (confirmed)="confirmed($event)"
  ></greco-select-community-agreement>
</greco-simple-dialog>
